import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";
import productMessages from "./components/ProductMessages.vue";

autoload();

window.app = new Vue({
  el: "#vue-knowledge-base-details",

  mixins: [initDom, auth, cart],

  components: {
    productMessages,
  },

  data() {
    return {
      myArticles: [],
      favorites: [],
      addComment: false,
      article: window._PR?.fullArticle || {},
      comment: {
        payload: {
          body: "",
          group: "article",
          type: "comment",
        },
        response: {
          type: "",
          message: "",
        },
      },
      messages: [],
    };
  },

  mounted() {
    let vm = this;

    if (Object.keys(vm.article).length > 0) {
      vm.getArticleMessages();
    }

    if (vm.isLoggedIn) {
      vm.getUsersSavedArticles();
    }
  },

  methods: {
    getUsersSavedArticles() {
      let userDocsUrl = "/api/proxify/me/articles";

      axios
        .get(userDocsUrl)
        .then(({ data: response }) => {
          this.myArticles = response;

          for (let favorite of response) {
            this.favorites.push(favorite.id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getArticleMessages() {
      let vm = this;
      let article = vm.article;
      let articleMessageUrl = `/api/proxify/domains/${article.domain}/articles/${article.id}/messages`;
      axios
        .get(articleMessageUrl, { params: { limit: 1000 } })
        .then(({ data: response }) => {
          vm.messages = response;
        })
        .catch((response) => {
          console.log(response);
        });
    },

    saveArticle(article) {
      let vm = this;
      let userDocUrl = `/api/proxify/me/articles/${article.id}`;
      axios
        .put(userDocUrl)
        .then(({ data: response }) => {
          vm.favorites.push(article.id);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    unsaveArticle(article) {
      let vm = this;
      let userDocUrl = `/api/proxify/me/articles/${article.id}`;
      axios
        .delete(userDocUrl)
        .then(({ data: response }) => {
          vm.favorites = vm.favorites.filter((e) => e !== article.id);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async submitComment() {
      let vm = this;
      let postMessageUrl = `/api/proxify/domains/cerakote/messages`;

      if (!vm.comment.payload.body) {
        vm.comment.response.type = "error";
        vm.$refs.notifications.add({
          delay: false,
          type: "warning",
          icon: "exclamation-triangle",
          title: "Unable to submit question",
          message: `Could not submit question, question message is required.`,
        });

        vm.dismissNotification();

        return;
      }

      try {
        let response = await axios.post(postMessageUrl, vm.comment.payload);
        let article = [];
        let articleProductUrl = `/api/proxify/domains/cerakote/messages/${response.data.id}/articles`;
        vm.comment.response.type = "success";
        vm.comment.response.message =
          "Thank you for your submission, we will get back to you shortly.";
        vm.comment.payload.body = "";
        vm.askQuestion = false;
        article.push(vm.article.id);

        await axios.put(articleProductUrl, article);

        vm.$refs.notifications.add({
          delay: false,
          type: "success",
          icon: "check",
          title: "Question submitted",
          message: `Your question was uploaded successfully, but must be
            approved before it is visible.`,
        });

        vm.dismissNotification();
      } catch (error) {
        vm.comment.response.type = "error";
        vm.comment.response.message =
          "Could not submit question, please try again.";

        vm.$refs.notifications.add({
          type: "error",
          icon: "exclamation-triangle",
          title: "Unable to submit comment",
        });

        vm.dismissNotification();
      }

      vm.comment.response.type = "";
    },

    dismissNotification() {
      setTimeout(() => {
        this.$refs.notifications.notifications = [];
      }, 1000);
    },

    cancelSubmitComment() {
      this.comment.payload.body = "";
      this.comment.response.type = "";
      this.addComment = false;
    },
  },
});
